import { IModalMethods } from "@/interfaces/Modal";
import { NoteForm } from "@/interfaces/Note";
import {
  useStoreCompanyNoteMutation,
  useUpdateCompanyNoteMutation,
} from "@/services/companies/notes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import {
  ElementRef,
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { SubmitHandler } from "react-hook-form";
import { ToastContentProps, toast } from "react-toastify";
import StoreNoteModal from "../StoreNoteModal";

interface StoreCompanyModalMethods {
  showOrHiddenModal: (id?: string, noteId?: string, message?: string) => void;
}

const StoreCompanyNoteModal: ForwardRefRenderFunction<
  StoreCompanyModalMethods
> = (_, ref) => {
  const [id, setId] = useState<string>();
  const [noteId, setNoteId] = useState<string>();
  const StoreNoteModalRef = useRef<ElementRef<typeof StoreNoteModal>>(null);
  const [storeCompanyNoteAsync] = useStoreCompanyNoteMutation();
  const [updateCompanyNoteAsync] = useUpdateCompanyNoteMutation();

  const showOrHiddenModal = (
    id?: string,
    noteId?: string,
    message?: string
  ) => {
    setId(id);
    setNoteId(noteId);
    StoreNoteModalRef.current?.showOrHiddenModal(message);
  };

  useImperativeHandle(ref, () => ({
    showOrHiddenModal,
  }));

  const onSubmit: SubmitHandler<NoteForm> = async (data) => {
    if (!id) return;

    toast.promise(
      noteId
        ? updateCompanyNoteAsync([id, noteId, data]).unwrap()
        : storeCompanyNoteAsync([id, data]).unwrap(),
      {
        pending: noteId
          ? "Mise à jour de la note en cours..."
          : "Ajout de la note en cours...",
        success: {
          render() {
            showOrHiddenModal();
            return (
              <p style={{ marginBottom: 0, textAlign: "center" }}>
                {noteId
                  ? "La note a bien été mise à jour !"
                  : "La note a bien été ajoutée !"}
              </p>
            );
          },
        },
        error: {
          render({ data }: ToastContentProps<FetchBaseQueryError>) {
            if (data?.status === 422) {
              return "Les champs que vous avez remplis semblent être incorrects.";
            }

            return "Une erreur est survenue";
          },
        },
      }
    );
  };

  return <StoreNoteModal ref={StoreNoteModalRef} onSubmit={onSubmit} />;
};

export default forwardRef(StoreCompanyNoteModal);
